export default __webpack_public_path__ + "static/media/EM0333.34I-41686_-24971_0.f0ec07da.jpg";